/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosCollectionListRequest = {
    sortField?: AptosCollectionListRequest.sortField;
    sortDirection?: AptosCollectionListRequest.sortDirection;
    period?: AptosCollectionListRequest.period;
    page?: number;
    size?: number;
};

export namespace AptosCollectionListRequest {

    export enum sortField {
        NAME = 'NAME',
        PRICE = 'PRICE',
        VOLUME = 'VOLUME',
        VOLUME_CHANGE = 'VOLUME_CHANGE',
        HOLDER = 'HOLDER',
        ITEM = 'ITEM',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }

    export enum period {
        H24 = 'H24',
        D7 = 'D7',
        D30 = 'D30',
        D90 = 'D90',
        Y1 = 'Y1',
        YTD = 'YTD',
    }


}

